import React, { useEffect, useCallback } from "react";
import InlineSVG from "svg-inline-react";
import { MapSvg } from "./SvgJs/map-source";
import { FILTERS } from "./constants/filters";

export const MapMobile = ({ listToDisplay, mapId, goExtendCard, filters }) => {

    const displaySelectedCircles = useCallback(() => {
        const isChasseAuxSaveurs = filters === FILTERS.CHASSE_AUX_SAVEURS;
        let VirtualMap = Array.from(
            document.querySelectorAll("#map-vector #LEGENDES g"),
        );

        if (mapId.length === 0) {
            VirtualMap.forEach((group) => {
                const isPlaceInList = listToDisplay.some(
                    (place) => `place-${place["map-id"]}` === group.id,
                );
                const isParkingGroup = group.id.startsWith("place-parking-");

                if (isParkingGroup) {
                    isChasseAuxSaveurs
                        ? group.classList.remove("visible")
                        : group.classList.add("visible");
                } else if (isPlaceInList) {
                    group.classList.add("visible");
                } else {
                    group.classList.remove("visible");
                }
            });
        } else {
            VirtualMap.forEach((group) => {
                const isMatchingPlace = listToDisplay.some(
                    (place) => `place-${mapId}` === group.id,
                );
                const isParkingGroup = group.id.startsWith("place-parking-");

                if (isParkingGroup) {
                    isChasseAuxSaveurs
                        ? group.classList.remove("visible")
                        : group.classList.add("visible");
                } else if (isMatchingPlace) {
                    group.classList.add("visible");
                } else {
                    group.classList.remove("visible");
                }
            });
        }
    }, [listToDisplay, mapId, filters]);

    const ZoomToPlace = useCallback((mapId) => {
        if (undefined !== mapId && 0 !== mapId.length) {
            document.querySelector("#Layer").style.removeProperty("transform");
            mapId = "place-" + mapId[0]["map-id"];
            let scale = 2;
            const circleElement = document.querySelector(`g#${mapId} circle`);
            if (!circleElement) {
                console.warn(`No SVG circle found for ${mapId}`);
                return;
            }
            let placePositionX = circleElement.getAttribute("cx");
            let placePositionY = circleElement.getAttribute("cy");
            document
                .querySelector("#Layer")
                .setAttribute(
                    "transform",
                    ` translate(${window.innerWidth * 1.5},${window.innerHeight / 2})scale(${scale}) translate(${-placePositionX}, ${-placePositionY})`,
                );
        } else {
            document.querySelector("#Layer").style.transform =
                "scale(1.3) translate(-15%,-0%)";
            document.querySelector("#Layer").removeAttribute("transform");
        }
    }, []);

    const extend = useCallback(
        (mapId) => {
            if (undefined !== mapId && mapId.length === 0) {
                let allCircles = document.querySelectorAll(
                    "#map-vector #LEGENDES g",
                );
                Array.from(allCircles).forEach((circle) =>
                    circle.classList.remove("selected"),
                );
                displaySelectedCircles();
            } else {
                let object = "place-" + mapId[0]["map-id"];
                let selectedCircle = document.querySelectorAll(
                    `#map-vector #LEGENDES g#${object}`,
                );
                let allCircles = document.querySelectorAll(
                    "#map-vector #LEGENDES g",
                );
                Array.from(allCircles).forEach((circle) =>
                    circle.classList.remove("visible"),
                );
                if (selectedCircle.length > 0) {
                    selectedCircle[0].classList.remove("visible");
                    selectedCircle[0].classList.add("selected");
                } else {
                    console.warn(`No SVG group found for ${object}`);
                }
            }
        },
        [displaySelectedCircles],
    );

    useEffect(() => {
        if (!goExtendCard) return;

        const groups = Array.from(
            document.querySelectorAll("#map-vector #LEGENDES g"),
        );
        const handlers = [];

        groups.forEach((group) => {
            if (group.id.startsWith("place-parking-")) {
                group.style.cursor = "default";
                group.style.pointerEvents = "none";
                return;
            }

            const isInList = listToDisplay.some(
                (place) => `place-${place["map-id"]}` === group.id,
            );
            if (!isInList) return;

            const handler = () => goExtendCard(group.id);
            group.style.cursor = "pointer";
            group.style.pointerEvents = "";
            group.addEventListener("click", handler);
            handlers.push({ group, handler });
        });

        return () => {
            handlers.forEach(({ group, handler }) => {
                group.removeEventListener("click", handler);
                group.style.cursor = "";
            });
        };
    }, [listToDisplay, goExtendCard]);

    useEffect(() => {
        ZoomToPlace(mapId);
        extend(mapId);
    }, [mapId, ZoomToPlace, extend]);

    useEffect(() => {
        displaySelectedCircles();
    }, [displaySelectedCircles]);

    return <InlineSVG src={MapSvg} className="mapMobile" />;
};
